import { objectOf, arrayOf, anyOf, maybe } from "@altostra/type-validations";
import { string, number, nullValidation } from "@altostra/type-validations/lib/primitives";

const isSourceObject = objectOf({
  uid: string,
  name: string,
});

export const isMediaLibrarySourcesResult = objectOf({
  sources: arrayOf(isSourceObject),
});

export const isMediaLibraryTeamsResult = objectOf({
  used_territories: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
});

export const isMediaLibraryTagsResult = objectOf({
  all_tags: arrayOf(string),
  used_tags: arrayOf(string),
});

export const isMediaLibraryAssetDataResult = objectOf({
  app_group_id: string,
  id: string,
  name: string,
  ext: string,
  type: string,
  size: number,
  url: anyOf(string, nullValidation),
  created_at: number,
  tag_names: arrayOf(string),
  territory_ids: arrayOf(string),
  ratio: maybe(number),
  known_height: maybe(number),
  known_width: maybe(number),
  last_edited_by: maybe(string, true),
  created_by: maybe(string, true),
  src: anyOf(string, nullValidation),
});

export const isImageDataResponse = objectOf({
  new_image_asset: isMediaLibraryAssetDataResult,
});

export const isFileUploadResponse = objectOf({
  id: string,
  name: string,
  path: string,
});

export const isMediaQueryResult = objectOf({
  hits: number,
  results: arrayOf(isMediaLibraryAssetDataResult),
});
